
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';


const About = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50">
      <div className="container mx-auto px-4 py-8">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6 flex items-center gap-2 hover:bg-white/80"
        >
          <ArrowLeft className="h-4 w-4" />
          {t('common.backToHome')}
        </Button>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-purple-600 to-blue-600 text-white p-8 rounded-t-2xl">
            <div className="text-center">
              <h1 className="text-4xl font-bold mb-4">{t('about.title')}</h1>
            </div>
            <p className="text-xl opacity-90">
              {t('about.mission')}
            </p>
          </div>

          <div className="bg-white p-8 rounded-b-2xl shadow-lg">
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">
                  {t('about.ourStoryTitle')}
                </h2>
                <div className="space-y-4 text-gray-600 text-justify">
                  <p>{t('about.storyParagraph1')}</p>
                  <p>{t('about.storyParagraph2')}</p>
                  <p>{t('about.storyParagraph3')}</p>
                </div>
              </div>
              <div className="flex items-center justify-center">
                <img
                  src="/lovable-uploads/96192a88-31f0-4183-a16f-672abc1c6e51.jpg"
                  alt="Pet family"
                  className="rounded-lg shadow-md w-full max-w-md"
                  loading="lazy"
                  decoding="async"
                  style={{ maxWidth: '448px', maxHeight: '448px' }}
                />
              </div>
            </div>

            <div className="border-t pt-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
                {t('about.valuesTitle')}
              </h2>
              <div className="grid md:grid-cols-3 gap-8">
                <div className="text-center">
                  <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-2xl">💝</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">
                    {t('about.value1Title')}
                  </h3>
                  <p className="text-gray-600">
                    {t('about.value1Description')}
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-2xl">📸</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">
                    {t('about.value2Title')}
                  </h3>
                  <p className="text-gray-600">
                    {t('about.value2Description')}
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-2xl">🤗</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">
                    {t('about.value3Title')}
                  </h3>
                  <p className="text-gray-600">
                    {t('about.value3Description')}
                  </p>
                </div>
              </div>
            </div>

            <div className="text-center pt-8 border-t mt-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">
                {t('about.joinUsTitle')}
              </h2>
              <p className="text-gray-600 mb-6">
                {t('about.joinUsDescription')}
              </p>
              <Button
                onClick={() => navigate('/auth')}
                className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700"
              >
                {t('common.getStarted')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
